/**
 * Telugu (India) locale for webhooks-ui.
 * Export is the "webhooks" subtree: host apps merge this into their i18n
 * resources as translation.webhooks so that t('webhooks.list.integrated') etc. resolve.
 */
import type { WebhooksLocale } from './en'

export const webhooksTeIn = {
  common: {
    createIntegration: `ఇంటిగ్రేషన్ సృష్టించు`,
    updateIntegration: `ఇంటిగ్రేషన్ నవీకరించు`,
    failedToSave: `సేవ్ చేయడం విఫలమైంది`,
    learnMore: `మరింత తెలుసుకోండి`,
    beta: `బీటా`,
  },
  list: {
    failedToLoad: `ఇంటిగ్రేషన్లు లోడ్ చేయడం విఫలమైంది`,
    noIntegrationsAvailable: `ఏ ఇంటిగ్రేషన్లూ అందుబాటులో లేవు`,
    integrated: `ఇంటిగ్రేట్ చేయబడింది`,
    learnMore: `మరింత తెలుసుకోండి`,
  },
  detail: {
    status: `స్థితి`,
    on: `ఆన్`,
    off: `ఆఫ్`,
    failedToLoad: `ఇంటిగ్రేషన్ లోడ్ చేయడం విఫలమైంది`,
    back: `← వెనక్కి`,
    webhooksV2Title: `Webhooks v2.0`,
    xlDentTitle: `స్క్రీన్ పాప్‌ల కోసం ఇంటిగ్రేషన్`,
    integrationTitle: `{{name}} కోసం ఇంటిగ్రేషన్`,
    webhooksV2Description: `మీరు అందించిన కాల్‌బ్యాక్ URL కి ఈవెంట్ పేలోడ్ పంపబడుతుంది. ఈవెంట్ సెలెక్టర్లను ఉపయోగించి పంపాల్సిన ఈవెంట్లను నిర్దేశించాలి`,
    xlDentDescription: `ఎవరు కాల్ చేస్తున్నారో తెలుసుకోండి. సమయం ఆదా చేయండి. త్వరగా సమాధానాలు పొందండి. వచ్చే మరియు వెళ్ళే కాల్‌లపై స్క్రీన్ పాప్ నోటిఫికేషన్లు అందుకోండి`,
    remoteIdLabel: `రిమోట్ ID`,
    practiceGuidLabel: `ప్రాక్టీస్ GUID`,
  },
  dolphin: {
    webhookUrl: `Webhook URL`,
  },
  webhooksV2: {
    remoteId: `రిమోట్ ID`,
    remoteIdPlaceholder: `మూల PBX గుర్తించడానికి ఉపయోగిస్తారు.`,
    callbackUrl: `కాల్‌బ్యాక్ URL`,
    callbackUrlPlaceholder: `https://yourdomain.com/mango/event-handler`,
    eventSelectors: `ఈవెంట్ సెలెక్టర్లు`,
    eventSelectorsLoadError: `ఈవెంట్ సెలెక్టర్లు లోడ్ చేయలేకపోయాయి — మళ్ళీ ప్రయత్నించడానికి రిఫ్రెష్ చేయండి.`,
    noEventsWarning: `మీరు ఏ ఈవెంట్ సెలెక్టర్లూ ఎంచుకోలేదు, దీని వల్ల ఆ URL కి ఏ ఈవెంట్లూ పంపబడవు. అయినా సేవ్ చేయాలా?`,
    goBack: `వెనక్కి వెళ్ళు`,
    saveAnyway: `అయినా సేవ్ చేయి`,
  },
  xlDent: {
    tableDescription: `Mango Voice ఎక్స్‌టెన్షన్లను వర్క్‌స్టేషన్ IP చిరునామాకు మ్యాప్ చేయండి.`,
    extensionName: `ఎక్స్‌టెన్షన్ పేరు`,
    extensionNumber: `ఎక్స్‌టెన్షన్ నంబర్`,
    workstationIp: `వర్క్‌స్టేషన్ IP చిరునామా`,
    enableDisable: `సక్రియం/నిష్క్రియం`,
    disabled: `నిష్క్రియం.`,
    ipPlaceholder: `e.g. 192.168.1.1:8888`,
    update: `నవీకరించు`,
    devicesNote: `గమనిక: ఏదైనా మార్పు జరిగినప్పుడు మీరు 'నా పరికరాలు'లో పరికరాన్ని నవీకరించాల్సి ఉంటుంది.`,
  },
  // ఈ విభాగంలోని వచనం apidocs.mangovoice.com తో సుసంగతంగా ఉండేందుకు
  // API డాక్యుమెంటేషన్ తో సమన్వయించి రాయబడింది.
  authKeys: {
    title: `అధికార కీలు`,
    description: `Mango Voice గ్లోబల్ APIలకు అభ్యర్థనలను ప్రమాణీకరించే మూడు-భాగాల టోకెన్‌ను రూపొందించండి. మీ ఇంటిగ్రేషన్ భాగస్వామితో దాన్ని పంచుకోండి, తద్వారా వారు మీ తరపున API కాల్స్ చేయగలరు.`,
    confidential: `టోకెన్లు గోప్యంగా ఉంచాలి. టోకెన్లను బహిరంగంగా బహిర్గతం చేయడం వల్ల డేటా దొంగతనం, నష్టం లేదా అవినీతి జరగవచ్చు.`,
    noKeys: `ఇంకా అధికార కీలు ఏవీ రూపొందించబడలేదు.`,
    generate: `రూపొందించు`,
    regenerate: `మళ్ళీ రూపొందించు`,
    remove: `తొలగించు`,
    copy: `కాపీ చేయి`,
    copied: `కాపీ చేయబడింది!`,
    apiDocsLabel: `API డాక్యుమెంటేషన్ చూడండి`,
    failedToLoad: `అధికార కీలు లోడ్ చేయడం విఫలమైంది`,
    failedToGenerate: `అధికార కీలు రూపొందించడం విఫలమైంది`,
    failedToRegenerate: `అధికార కీలు మళ్ళీ రూపొందించడం విఫలమైంది`,
    failedToRemove: `అధికార కీలు తొలగించడం విఫలమైంది`,
    confirmRegenerateTitle: `అధికార కీలు మళ్ళీ రూపొందించు`,
    confirmRegenerateBody: `అధికార కీలను మళ్ళీ రూపొందించడం వల్ల ప్రస్తుత ఇంటిగ్రేషన్లు నిలిపివేయబడవచ్చు. మీరు కొనసాగించాలనుకుంటున్నారా?`,
    confirmRemoveTitle: `అధికార కీలు తొలగించు`,
    confirmRemoveBody: `అధికార కీలను తొలగించడం వల్ల ప్రస్తుత ఇంటిగ్రేషన్లు నిలిపివేయబడవచ్చు. మీరు కొనసాగించాలనుకుంటున్నారా?`,
    confirmCancel: `రద్దు చేయి`,
    confirmProceed: `కొనసాగించు`,
    combinedToken: `మిళిత టోకెన్`,
    combinedTokenHint: `API అభ్యర్థనలలో పాత్ వేరియబుల్స్‌గా ఉపయోగించబడుతుంది`,
    formatIdent1: `ident1`,
    formatIdent2: `ident2`,
    formatIdent3: `ident3`,
  },
  admin: {
    apiAccess: {
      title: `API యాక్సెస్`,
      selectPbx: `PBX ఎంచుకోండి`,
      selectCompanyFirst: `ముందుగా కంపెనీని ఎంచుకోండి`,
      noPbxSelected: `అధికార కీలు నిర్వహించడానికి పైన కంపెనీ మరియు PBX ఎంచుకోండి.`,
    },
    // admin.list is an internal admin3 namespace — English strings are intentional
    list: {
      title: `Webhook Integrations`,
      description: `View and manage webhook integration status across all PBXes for a company`,
      companyLabel: `Company`,
      companyPlaceholder: `Select a company…`,
      pbxFilter: `PBX`,
      allPbxes: `All PBXes`,
      integrationFilter: `Integration`,
      allIntegrations: `All Integrations`,
      noCompanySelected: `Select a company to view integrations`,
      noIntegrationsFound: `No integrations found`,
      columnStatus: `Status`,
      columnActive: `Active`,
      notIntegrated: `Not integrated`,
    },
  },
} satisfies WebhooksLocale
